import React, { Component } from 'react';
import { connect } from 'react-redux';
import MoviesResultsSoonInCinema from "../../../../SHARED/components/movieresultssoonincinema/movieresultssoonincinema.component";
import moment from 'moment';
import {capitalizeFirstLetter} from "../../../../SHARED/helpers/general.helper";

class ResultsSoonInCinema extends Component {

    getCards() {
       return this.props.recentMoviesFiltered;
    }

    render() {
        const currentDate = capitalizeFirstLetter(moment(this.props.recentMoviesFiltered.current_date+'01').locale('ro').format('MMMM'));
        return (
            <div className="results-soon-in-cinema">
                <MoviesResultsSoonInCinema cards={this.getCards()} selectedMonth={currentDate}/>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    recentMoviesFiltered: state.movies.recentMoviesFiltered
});
export default connect(mapStateToProps, {})(ResultsSoonInCinema);




// WEBPACK FOOTER //
// ./src/FO/components/soonincinema/containers/resultssoonincinema.component.js